import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { TranslationService } from '../services/translation-service';

@Injectable({ providedIn: 'root' })
export class LanguageGuard implements CanActivate {
  constructor(private i18n: TranslationService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const lang = route.paramMap.get('lang') || '';

    // Si el lang no es válido → redirigir a defaultLang pero conservando el resto del path
    if (!this.i18n.isSupported(lang)) {
      const parts = state.url.split('?')[0].split('/').filter(Boolean);
      return this.router.createUrlTree(['/', this.i18n.getLanguage(), ...parts], {
        queryParams: route.queryParams,
      });
    }

    // Sincroniza el servicio si el lang difiere
    if (lang !== this.i18n.getLanguage()) {
      this.i18n.setLanguage(lang, { updateUrl: false });
    }

    return true;
  }
}
